import { BaseService } from "./BaseService";

export class AboutService extends BaseService {
  constructor() {
    super("about");
  }
}